// src/lib/api/utilities/tasks.js
import { supabase } from '../../supabase'
import { getValidatedCompanyId } from '../shared/helpers'
import { withErrorHandling, createSuccessResponse } from '../shared/errors'
import { logger } from '../../logger'

/**
 * Get tasks
 * Migrated from supabaseApi.js lines 528-549
 */
const _getTasks = async (companyId = null) => {
  logger.utilities('getTasks called with companyId:', companyId)
  
  const resolvedCompanyId = companyId || await getValidatedCompanyId()
  if (!resolvedCompanyId) {
    console.warn('[utilities] No company ID found')
    return createSuccessResponse([])
  }

  const { data, error } = await supabase
    .from('tasks')
    .select('*')
    .eq('company_id', resolvedCompanyId)
    .order('created_at', { ascending: false })
    
  if (error) {
    console.error('[utilities] Error fetching tasks:', error)
    throw error
  }

  logger.utilities('getTasks success, found', data?.length || 0, 'tasks')
  return createSuccessResponse(data || [])
}

// Export function with error handling
export const getTasks = withErrorHandling(_getTasks, 'get tasks', 'tasks')